import { Ticket } from "lucide-react";
import type { CouponItem } from "../types";

interface CouponCardProps {
  coupon: CouponItem;
}

export function CouponCard({ coupon }: CouponCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-amber-200/70 bg-white shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-md">
      {/* Perforated edge accent */}
      <div className="absolute inset-y-0 left-0 w-2 bg-gradient-to-b from-amber-400 via-amber-500 to-amber-600" />
      <div
        className="pointer-events-none absolute left-[1.35rem] top-0 h-full w-px"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to bottom, transparent 0 6px, rgb(226 232 240) 6px 10px)",
        }}
      />
      {/* Side notches */}
      <div className="pointer-events-none absolute -left-2.5 top-1/2 z-10 h-5 w-5 -translate-y-1/2 rounded-full border border-amber-200 bg-[#f8fafc]" />
      <div className="pointer-events-none absolute -right-2.5 top-1/2 z-10 h-5 w-5 -translate-y-1/2 rounded-full border border-amber-200 bg-[#f8fafc]" />

      <div className="flex items-start gap-3 py-5 pl-8 pr-5 sm:pl-10">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600 transition group-hover:scale-105">
          <Ticket className="h-5 w-5" />
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-2">
            {coupon.code ? (
              <span className="rounded-md bg-slate-900 px-2 py-0.5 font-mono text-xs font-bold tracking-wider text-amber-300">
                {coupon.code}
              </span>
            ) : null}
            <span className="inline-flex rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-emerald-700 ring-1 ring-emerald-100">
              {coupon.status}
            </span>
          </div>
          {coupon.title ? (
            <p className="mt-2 text-base font-semibold text-slate-900">
              {coupon.title}
            </p>
          ) : null}
          {coupon.discount ? (
            <p className={`text-lg font-semibold text-slate-900 ${coupon.title ? "mt-1" : "mt-2"}`}>
              {coupon.discount}
            </p>
          ) : null}
          {coupon.description ? (
            <p className="mt-0.5 text-sm text-slate-500">{coupon.description}</p>
          ) : null}
          {coupon.expiry ? (
            <p className="mt-1 text-xs text-amber-700/80">{coupon.expiry}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
